/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DispatchTransporteurDto } from '../models/dispatch-transporteur-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des dispatchs de transporteurs
 */
@Injectable({
  providedIn: 'root',
})
export class DispatchTransporteurService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation dispatchTransporteurGetListAll
   */
  static readonly DispatchTransporteurGetListAllPath = '/api/dispatch-transporteur/list/{transporteurId}';

  /**
   * Renvoie la liste des dispatchs du transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurGetListAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGetListAll$Response(params: {

    /**
     * Identifiant du transporteur
     */
    transporteurId: number;
  }): Observable<StrictHttpResponse<Array<DispatchTransporteurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurGetListAllPath, 'get');
    if (params) {
      rb.path('transporteurId', params.transporteurId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DispatchTransporteurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des dispatchs du transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurGetListAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGetListAll(params: {

    /**
     * Identifiant du transporteur
     */
    transporteurId: number;
  }): Observable<Array<DispatchTransporteurDto>> {

    return this.dispatchTransporteurGetListAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DispatchTransporteurDto>>) => r.body as Array<DispatchTransporteurDto>)
    );
  }

  /**
   * Path part for operation dispatchTransporteurGetListActifs
   */
  static readonly DispatchTransporteurGetListActifsPath = '/api/dispatch-transporteur/list-actifs';

  /**
   * Renvoie la liste des dispatchs associés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DispatchTransporteurDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DispatchTransporteurDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des dispatchs associés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGetListActifs(params?: {
  }): Observable<Array<DispatchTransporteurDto>> {

    return this.dispatchTransporteurGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DispatchTransporteurDto>>) => r.body as Array<DispatchTransporteurDto>)
    );
  }

  /**
   * Path part for operation dispatchTransporteurPost
   */
  static readonly DispatchTransporteurPostPath = '/api/dispatch-transporteur/{transporteurId}';

  /**
   * Crée un dispatch pour le transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurPost$Response(params: {

    /**
     * Identifiant du transporteur
     */
    transporteurId: number;

    /**
     * Dispatch de transporteur
     */
    body: DispatchTransporteurDto
  }): Observable<StrictHttpResponse<DispatchTransporteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurPostPath, 'post');
    if (params) {
      rb.path('transporteurId', params.transporteurId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DispatchTransporteurDto>;
      })
    );
  }

  /**
   * Crée un dispatch pour le transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurPost(params: {

    /**
     * Identifiant du transporteur
     */
    transporteurId: number;

    /**
     * Dispatch de transporteur
     */
    body: DispatchTransporteurDto
  }): Observable<DispatchTransporteurDto> {

    return this.dispatchTransporteurPost$Response(params).pipe(
      map((r: StrictHttpResponse<DispatchTransporteurDto>) => r.body as DispatchTransporteurDto)
    );
  }

  /**
   * Path part for operation dispatchTransporteurLoadList
   */
  static readonly DispatchTransporteurLoadListPath = '/api/dispatch-transporteur/load-list/{transporteurId}';

  /**
   * Renvoie la liste des dispatchs du transporteur spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurLoadList$Response(params: {

    /**
     * Identifiant du transporteur
     */
    transporteurId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurLoadListPath, 'post');
    if (params) {
      rb.path('transporteurId', params.transporteurId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des dispatchs du transporteur spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurLoadList(params: {

    /**
     * Identifiant du transporteur
     */
    transporteurId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.dispatchTransporteurLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation dispatchTransporteurGet
   */
  static readonly DispatchTransporteurGetPath = '/api/dispatch-transporteur/{id}';

  /**
   * Renvoie le dispatch de transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGet$Response(params: {

    /**
     * Identifiant du dispatch de transporteur
     */
    id: number;
  }): Observable<StrictHttpResponse<DispatchTransporteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DispatchTransporteurDto>;
      })
    );
  }

  /**
   * Renvoie le dispatch de transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGet(params: {

    /**
     * Identifiant du dispatch de transporteur
     */
    id: number;
  }): Observable<DispatchTransporteurDto> {

    return this.dispatchTransporteurGet$Response(params).pipe(
      map((r: StrictHttpResponse<DispatchTransporteurDto>) => r.body as DispatchTransporteurDto)
    );
  }

  /**
   * Path part for operation dispatchTransporteurPut
   */
  static readonly DispatchTransporteurPutPath = '/api/dispatch-transporteur/{id}';

  /**
   * Met à jour le dispatch de transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurPut$Response(params: {

    /**
     * Identifiant du dispatch de transporteur à mettre à jour
     */
    id: number;

    /**
     * Dispatch de transporteur
     */
    body: DispatchTransporteurDto
  }): Observable<StrictHttpResponse<DispatchTransporteurDto>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DispatchTransporteurDto>;
      })
    );
  }

  /**
   * Met à jour le dispatch de transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurPut(params: {

    /**
     * Identifiant du dispatch de transporteur à mettre à jour
     */
    id: number;

    /**
     * Dispatch de transporteur
     */
    body: DispatchTransporteurDto
  }): Observable<DispatchTransporteurDto> {

    return this.dispatchTransporteurPut$Response(params).pipe(
      map((r: StrictHttpResponse<DispatchTransporteurDto>) => r.body as DispatchTransporteurDto)
    );
  }

  /**
   * Path part for operation dispatchTransporteurDelete
   */
  static readonly DispatchTransporteurDeletePath = '/api/dispatch-transporteur/{id}';

  /**
   * Supprime le dispatch de transporteur spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurDelete$Response(params: {

    /**
     * Identifiant du dispatch de transporteur à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le dispatch de transporteur spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurDelete(params: {

    /**
     * Identifiant du dispatch de transporteur à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.dispatchTransporteurDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation dispatchTransporteurPost2
   */
  static readonly DispatchTransporteurPost2Path = '/api/dispatch-transporteur';

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurPost2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurPost2$Response(params: {

    /**
     * Entité
     */
    body: DispatchTransporteurDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurPost2Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurPost2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurPost2(params: {

    /**
     * Entité
     */
    body: DispatchTransporteurDto
  }): Observable<void> {

    return this.dispatchTransporteurPost2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation dispatchTransporteurGetList
   */
  static readonly DispatchTransporteurGetListPath = '/api/dispatch-transporteur/list';

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGetList$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchTransporteurGetList(params?: {
  }): Observable<void> {

    return this.dispatchTransporteurGetList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation dispatchTransporteurLoadList2
   */
  static readonly DispatchTransporteurLoadList2Path = '/api/dispatch-transporteur/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchTransporteurLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurLoadList2$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchTransporteurService.DispatchTransporteurLoadList2Path, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchTransporteurLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchTransporteurLoadList2(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.dispatchTransporteurLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
